import { render } from "./zhuanchang-news.vue?vue&type=template&id=cf34e81c&scoped=true"
import script from "./zhuanchang-news.vue?vue&type=script&lang=js"
export * from "./zhuanchang-news.vue?vue&type=script&lang=js"

import "./zhuanchang-news.vue?vue&type=style&index=0&id=cf34e81c&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf34e81c"]])

export default __exports__